var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __await = (this && this.__await) || function (v) { return this instanceof __await ? (this.v = v, this) : new __await(v); }
var __asyncGenerator = (this && this.__asyncGenerator) || function (thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
};
/**
 * Returns a pseudo-random peer that supports the given protocol.
 * Useful for protocols such as store and light push
 */
export function selectRandomPeer(peersIter) {
    var peersIter_1, peersIter_1_1;
    var e_1, _a;
    return __awaiter(this, void 0, void 0, function* () {
        const peers = [];
        try {
            for (peersIter_1 = __asyncValues(peersIter); peersIter_1_1 = yield peersIter_1.next(), !peersIter_1_1.done;) {
                const peer = peersIter_1_1.value;
                peers.push(peer);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (peersIter_1_1 && !peersIter_1_1.done && (_a = peersIter_1.return)) yield _a.call(peersIter_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        if (peers.length === 0)
            return;
        const index = Math.round(Math.random() * (peers.length - 1));
        return peers[index];
    });
}
/**
 * Returns the list of peers that supports the given protocol.
 */
export function getPeersForProtocol(libp2p, protocols) {
    return __asyncGenerator(this, arguments, function* getPeersForProtocol_1() {
        var e_2, _a;
        try {
            for (var _b = __asyncValues(libp2p.peerStore.getPeers()), _c; _c = yield __await(_b.next()), !_c.done;) {
                const peer = _c.value;
                let peerFound = false;
                for (let i = 0; i < protocols.length; i++) {
                    if (peer.protocols.includes(protocols[i])) {
                        peerFound = true;
                        break;
                    }
                }
                if (!peerFound) {
                    continue;
                }
                yield yield __await(peer);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) yield __await(_a.call(_b));
            }
            finally { if (e_2) throw e_2.error; }
        }
    });
}
//# sourceMappingURL=select_peer.js.map